export default {
  data: [
    {
      dairy: false,
      favorite: true,
      flavor: 'Royal',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Almond',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Barley',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Black',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cappuccino',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Chocolate',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Coconut',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Coffee',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Ginger',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Honey',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Honeydew',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Ice Coffee',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Jasmine',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lavender',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pumpkin',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Sesame',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Taro',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Thai',
      premium: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/milk_tea_flavors.js